/**
 * How much detail message notifications reveal (toast, OS notification, and
 * inbox row). Per alias; conversations and Spaces are configured separately
 * because conversations tend to be more private.
 *
 * @module api/notification-display
 */
export const CONVERSATION_NOTIFICATION_DISPLAY_FIELDS = ['showSender', 'showConversationName'];
export const SPACE_NOTIFICATION_DISPLAY_FIELDS = ['showSender', 'showChannel', 'showSpace'];
export const DEFAULT_NOTIFICATION_DISPLAY = Object.freeze({
    conversations: Object.freeze({ showSender: true, showConversationName: true }),
    spaces: Object.freeze({ showSender: true, showChannel: true, showSpace: true }),
});
function pickBooleans(raw, fields, fallback) {
    const source = raw && typeof raw === 'object' ? raw : {};
    const out = {};
    for (const field of fields) {
        const value = source[field];
        out[field] = typeof value === 'boolean' ? value : fallback[field];
    }
    return out;
}
/** Missing or malformed fields fall back to {@link DEFAULT_NOTIFICATION_DISPLAY}. */
export function resolveNotificationDisplay(raw) {
    const source = raw && typeof raw === 'object' ? raw : {};
    return {
        conversations: pickBooleans(source.conversations, CONVERSATION_NOTIFICATION_DISPLAY_FIELDS, DEFAULT_NOTIFICATION_DISPLAY.conversations),
        spaces: pickBooleans(source.spaces, SPACE_NOTIFICATION_DISPLAY_FIELDS, DEFAULT_NOTIFICATION_DISPLAY.spaces),
    };
}
//# sourceMappingURL=notification-display.js.map